<template>
	<div class="e-poster max-content">
		<top :title="title" :color="color"></top>
		<div class="banner-show">
			<div class="cover">
				<van-swipe :autoplay="3000" indicator-color="white" :show-indicators="false">
					<van-swipe-item v-for="(item,key,index) in swiperImg" :key="index">
					  <img :src="item.image" alt="">
					</van-swipe-item>
				</van-swipe>
			</div>
		</div>
		<div v-if="meeting_id==295">
			<div class="list" style="padding: 0 10px 10px;border-radius: 10px;box-shadow: 0 0 10px 2px rgb(218 218 218);margin:10px 0 30px;">
				<div class="item" v-for="(value,index) in eposters.slice(0,5)" :key="index" @click="goTo(value.bind_url)">
					<div class="cover" >
						<img :src="value.banner"/>
						<!-- <h3>{{value.name}}</h3> -->
						<h3 v-if="show_writer">
							作者：<span v-for="(item,index) in value.writers" :key="index">{{item.name}}</span>
						</h3>
					</div>   
				</div>
			</div>
			<div class="list" style="padding: 0 10px 10px;border-radius: 10px;box-shadow: 0 0 10px 2px rgb(218 218 218);margin-bottom: 30px;">
				<div class="item" v-for="(value,index) in eposters.slice(5,9)" :key="index" @click="goTo(value.bind_url)">
					<div class="cover" >
						<img :src="value.banner"/>
						<!-- <h3>{{value.name}}</h3> -->
						<h3 v-if="show_writer">
							作者：<span v-for="(item,index) in value.writers" :key="index">{{item.name}}</span>
						</h3>
					</div>   
				</div>
			</div>
			<div class="list" style="padding: 0 10px 10px;border-radius: 10px;box-shadow: 0 0 10px 2px rgb(218 218 218);margin-bottom: 30px;">
				<div class="item" v-for="(value,index) in eposters.slice(9,11)" :key="index" @click="goTo(value.bind_url)">
					<div class="cover" >
						<img :src="value.banner"/>
						<!-- <h3>{{value.name}}</h3> -->
						<h3 v-if="show_writer">
							作者：<span v-for="(item,index) in value.writers" :key="index">{{item.name}}</span>
						</h3>
					</div>   
				</div>
			</div>
			<div class="list" style="padding: 0 10px 10px;border-radius: 10px;box-shadow: 0 0 10px 2px rgb(218 218 218);margin-bottom: 30px;">
				<div class="item" v-for="(value,index) in eposters.slice(11)" :key="index" @click="goTo(value.bind_url)">
					<div class="cover" >
						<img :src="value.banner"/>
						<!-- <h3>{{value.name}}</h3> -->
						<h3 v-if="show_writer">
							作者：<span v-for="(item,index) in value.writers" :key="index">{{item.name}}</span>
						</h3>
					</div>   
				</div>
			</div>
		</div>
        <div class="list" v-else>
            <!-- <div class="item" v-for="(item,index) in eposters" :key="index"> -->
            <div class="item" v-for="(value,key,index) in eposters" :key="index" @click="goTo(value.bind_url)">
				<div class="cover" >
					<img :src="value.banner"/>
                    <h3 class="title">{{value.name}}</h3>
                    <h3 v-if="Object.keys(value.writers).length!==0 && show_writer">
				        作者：<span v-for="(item,index) in value.writers" :key="index">{{item.name}}</span>
                    </h3>
				</div>   
			</div>
        </div>
	</div>
</template>
<script>
	import {MeetingsCarousel,Eposters,ButtonDetail,MeetingsDetails} from '../../../config/interface.js'
	import Top from '../components/Top'
	export default{
		components: {
    		Top
  		},
		data(){
			return{
                meeting_id:this.$route.query.meeting_id?this.$route.query.meeting_id:this.$route.query.MT_id,
				button_id:this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id,
				swiperImg:{},     //轮播图
                eposters:[],
                show_writer:0,
				title:'',
				color:'#FFFFFF'
			}
		},
		mounted(){
			this.getMeetingCarousel();
            this.getPosters();
			this.getButtonData();
            this.getShow();
		},
		methods:{
			//会议轮播
			getMeetingCarousel(){
				const url=MeetingsCarousel;
				let params={
					meeting_id:this.meeting_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.swiperImg=data;
					}
				})
			},
            getPosters(){
                const url=Eposters;
				let params={
					meeting_id:this.meeting_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.eposters=data;
					}
				})
            },
            getShow(){
                const url=MeetingsDetails;
				let params={
					meeting_id:this.meeting_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.show_writer=data.show_wallposter_writer;
					}
				})
            },
			//获取按钮信息
			getButtonData(){
				if(this.button_id){
					const url=ButtonDetail;
					let params={
                    	button_id:this.button_id
					}
					const method="POST";
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							document.title=res.data.share_title;
							this.title=res.data.name;
							if(res.data.theme_color_hex){
								this.color=res.data.theme_color_hex
							}else{
								this.color='#901D22'
							}
							if(common.is_weixin()){
								let data=res.data;
								common.wxShare(data.share_title,data.share_sub_title,data.share_img);
							}
						}
					})

				}
			},
			goTo(url){
				window.location.href=url;
			}
		}
	}
</script>
<style lang="scss" scoped>
	.e-poster{
        // padding: 10px;
		.banner-show{
			width:100%;
			.cover{
				width:100%;
				// margin-bottom:14px;
				img{
					width:100%;
				}
			}
		}
        .list{
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			padding:0 10px;
			.item{
				width:48%;
                border-radius: 10px;
                background: white;
				.title{
					max-height: 44px;
					padding: 0 10px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					line-clamp: 2;
                     overflow:hidden; //超出的文本隐藏
                     text-overflow:ellipsis; //溢出用省略号显示
					 text-align: center;
				}
                h3{
                    padding-left:5px;
                    line-height: 22px;
					font-size:14px;

			
                    //  white-space:nowrap; //溢出不换行 （只显示一行）
					span{
						margin-right:3px;
					}
                }
                img{
                    border-radius: 10px 10px 0 0;
                }
			}
				
		}
        .item{
            margin-top:10px;
            .cover{
				position:relative;
			    margin:0 0 12px 0;
                border-radius: 10px;
				img{
					width:100%;
				}
			}
        }
		
	}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/EposterLink.vue